import type { AxiosRequestConfig } from 'axios'
import { resolveApiBaseUrl } from '@/lib/api-origin'
export const withSilentErrorToast = { _skipErrorToast: true } as AxiosRequestConfig & {
  _skipErrorToast: boolean
}
export const normalizeArray = <T>(
  payload: unknown,
  primaryKey: string,
  fallbackKeys: string[] = ['items', 'data']
): T[] => {
  if (Array.isArray(payload)) return payload as T[]
  if (!payload || typeof payload !== 'object') return []
  const record = payload as Record<string, unknown>
  if (Array.isArray(record[primaryKey])) return record[primaryKey] as T[]
  for (const key of fallbackKeys) {
    if (Array.isArray(record[key])) return record[key] as T[]
  }
  return []
}
export const apiBaseUrl = () => resolveApiBaseUrl()

/** @deprecated Use apiBaseUrl() — recordings are served via the same-origin API proxy. */
export const recordingsBaseUrl = () => apiBaseUrl()
